<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <div class="popup_video_container relative" v-if="!has_link">
      <div class="option-bar" v-if="is_closable" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <div
        class="scroll-helper support-container"
        @click="prevent_close($event)"
      >
        <strong>For Eye Care Support </strong><br />
        Please call <strong>1-800-416-8780 </strong><br />
        or click
        <a
          href="mailto:eyecaresupport@allergan.com"
          rel="nofollow"
          target="_blank"
          >here</a
        >
        to email.
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "SupportPopup",
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "sections_content",
      "current_secondary_section",
      "current_secondary_sub_section"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/";

      return str;
    },
    img_style() {
      let style = {};

      if ("undefined" != typeof this.getCurrentSectionContent().style) {
        style = this.getCurrentSectionContent().style;
      }
      return style;
    },
    img_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/" +
        this.getCurrentSectionContent().src
      );
    },
    link_src() {
      return this.getCurrentSectionContent().link;
    },
    has_link() {
      return (
        "undefined" != typeof this.getCurrentSectionContent().link &&
        this.getCurrentSectionContent().link.length > 0
      );
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    is_video_src() {
      return (
        undefined != typeof this.$store.state.popup_img_src &&
        this.$store.state.popup_img_src != ""
      );
    },
    video_popup_class() {
      return "popup " + this.loading;
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    click_close_popup(e) {
      if (this.is_closable) {
        e.preventDefault();
        this.close_popup(e);
      }
    },
    close_popup(e) {
      console.log("close popup");
      //if(e)
      //e.preventDefault();

      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_interactive_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_img_src, 10)
        );
      }

      this.$bus.$emit("send_interactive_msg", "popupClosed", 1);
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    }
  },
  mounted() {
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 44, 107, 0.8);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.support-container {
  background: #0060ac;
  color: #fff;
  font-size: 2.2em;
  padding: 2em 3em;
}
.support-container a[href^="mailto"] {
  text-decoration: underline;
  font-weight: bold;
}

.option-bar {
  position: absolute;
  top: 0;
  right: 0;
}
.close-link {
  color: #fff;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 60px;
  height: 60px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  cursor: pointer;
  transform: translate3d(52%, -52%, 0);
}
.popup_video_container {
  align-self: center;
  margin: 0 0;
}
.popup_video_container img {
  max-height: 90vh;
  object-fit: contain;
}
.scroll-helper {
  max-height: 90vh;
  overflow-y: auto;
}

@media only screen and (max-width: 1110px),
  only screen and (max-height: 460px) {
  .back-bar a {
    width: 30px;
    height: 30px;
    transform: translate3d(40%, -40%, 0);
  }
  .support-container {
    font-size: 1em;
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/SupportPopup.vue